import { ManifestClient } from './manifest';

let initializedResolve;
let hasInitialized = false;
let currentPayload = {
    treatments: {
        company: [],
        user: []
    }
}

let initialized = new Promise((resolve) => {
    initializedResolve = resolve;
})

export const Environments = {
    STAGING: 'staging',
    PRODUCTION: 'production'
}

export const Events = {
    MANIFEST_UPDATE: 'mi-manifest-update'
}

export const RefreshEventReasons = {
    USER_REQUESTED: 'user requested',
    DATA_EXPIRED: 'data expired',
    INTERNAL_REFRESH: 'internal refresh',
    RE_INITIALIZATION: 're-initialization'
}

export class Configuration {
    static getConfiguration(env) {
        if(env === Environments.STAGING) {
            return {
                baseUri: 'https://staging.meltwater.net/manifest',
                cookieDomain: '.meltwater.net',
                resetTokenUrl: 'https://live.staging.gaf-identity-provider.meltwater.io/auth/resetToken',
                logoutUrl: 'https://live.staging.gaf-identity-provider.meltwater.io/logout'
            }
        } else if (env === Environments.PRODUCTION) {
            return {
              baseUri: "https://app.meltwater.com/manifest",
              cookieDomain: ".meltwater.com",
              resetTokenUrl: "https://app.meltwater.com/auth/resetToken",
              logoutUrl: "https://app.meltwater.com/logout",
            };
        } else {
            throw new Error(`Configuration - unknown environment provided. Provided Value ${env}`);
        }
    }
}

export class Initializer {
    static initialize(env, payload, options = {}) {
      let reInitialize = false;
      
      const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
      }

      if (!hasInitialized) {
        const client = new ManifestClient(
          { ...Configuration.getConfiguration(env), ...options },
          payload
        );
        initializedResolve();
        hasInitialized = true;

        if (payload) {
            currentPayload = { ...client.payload };
        }

        client.navigation.verifyAppAccess();
        return;
      }

      if(!payload || isEmpty(payload)) {
        return;
      }

      // If we have initialized but are sending another request 
      // (most likely from another app) lets combine the payloads
      if (hasInitialized) {
        // Loop through the payload and if there is a new company treatment
        // Add it to the currentPayload
        payload.treatments.company.map((item) => {
          if (currentPayload.treatments.company.includes(item)) {
            return;
          }
          reInitialize = true;
          currentPayload.treatments.company.push(item);
        });  

        // Loop through the payload and if there is a new user treatment
        // Add it to the currentPayload
        payload.treatments.user.map((item) => {
          if (currentPayload.treatments.user.includes(item)) {
            return;
          }
          reInitialize = true;
          currentPayload.treatments.user.push(item);
        });

        if (reInitialize) {
          ManifestClient.getInstance().then(instance => {
            instance.payload = currentPayload;
            instance.__refreshData(RefreshEventReasons.RE_INITIALIZATION);
          });
        }  
      } 
    }

    static onInitialized() {
        return initialized;
    }
}